import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../theme";

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.h2`
  color: ${theme.colors.text.primary};
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: bold;
  margin-bottom: 0px;
  font-family: "Inter", sans-serif;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  font-weight: 400; /* regular */
  color: ${theme.colors.text.tertiary};
  font-family: "Inter Regular", "Inter", sans-serif;
  margin-bottom: 40px;

  letter-spacing: -0.4px;
  line-height: 26px;
`;

const StatsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  background: ${theme.colors.text.quaternary};
  border: 1px solid ${theme.colors.text.quinary};
  border-radius: 20px;

  @media (max-width: 768px) {
    gap: 2rem;
    padding: 1rem;
  }
`;

const Stat = styled(motion.div)`
  padding: 4rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  color: ${theme.colors.text.primary};

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 600px) {
    padding: 1.5rem;
  }
`;

const StatNumber = styled(motion.div)`
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: bold;
  color: ${theme.colors.text.secondary};
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const StatLabel = styled.div`
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: ${theme.colors.text.secondary};
  margin-top: 1rem;
  font-family: "Inter", sans-serif;
  text-align: center;
`;

const SC = {
  Container,
  Title,
  Subtitle,
  StatsContainer,
  Stat,
  StatNumber,
  StatLabel,
};

export default SC;
